import sendToClientAnalytics from '@stencil/client-side-analytics/src/send-to-client-analytics';

export function trackApiFailureDweb(data) {
  sendToClientAnalytics({
    serviceApp: 'avatar',
    ...data,
  });
}
